import React, { useState, useRef, useEffect } from 'react';
import { useConditionalyOutsideAlerter } from '@/hocs';
import styles from './CustomMultiSelect.module.css';
import SubmitButton from '../submitButton';
import CloseButton from '../closeButton';

export default function CustomMultiSelect({
  display,
  setDisplay,
  setFilter,
  options,
  selectedFilters,
  filterButtonRef,
}) {
  const [selectedStatuses, setSelectedStatuses] = useState(
    selectedFilters || []
  );
  const wrapperRef = useRef(null);

  useConditionalyOutsideAlerter(
    wrapperRef,
    () => setDisplay('none'),
    (event) => {
      // Don't close if clicking on the filter button
      if (
        filterButtonRef &&
        filterButtonRef.current &&
        filterButtonRef.current.contains(event.target)
      ) {
        return false;
      }
      return true;
    }
  );

  const toggleStatus = (statusValue) => {
    setSelectedStatuses((prev) =>
      prev.some((s) => s.value === statusValue)
        ? prev.filter((s) => s.value !== statusValue)
        : [...prev, options.find((opt) => opt.value === statusValue)]
    );
  };

  const resetFilters = () => {
    setSelectedStatuses([]);
    setFilter([]);
    setDisplay('none');
  };

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
  };

  const handleLabelClick = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    setSelectedStatuses(selectedFilters);
  }, [selectedFilters]);

  return (
    <div
      ref={wrapperRef}
      className={styles.dropdownContainer}
      style={{ display }}>
      <div className={styles.dropdownBody}>
        {options.map((option) => (
          <label
            key={option.value}
            className={styles.checkboxContainer}
            onClick={handleLabelClick}>
            <input
              type="checkbox"
              checked={selectedStatuses.some((s) => s.value === option.value)}
              onChange={() => toggleStatus(option.value)}
              onClick={handleCheckboxClick}
              className={styles.customCheckbox}
            />
            <span className={styles.labelText}>{option.label}</span>
          </label>
        ))}
        <div className={styles.buttonContainer}>
          <CloseButton
            color="#131517"
            onClick={resetFilters}
            text="Cancel"
            className="flex-1 min-w-unset"
          />
          <SubmitButton
            onClick={() => {
              setFilter(selectedStatuses);
              setDisplay('none');
            }}
            text="Apply"
            className="flex-1 min-w-unset"
          />
        </div>
      </div>
    </div>
  );
}
